import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const WishlistMisc = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='m19.513 14.44-.008.007-.007.008-4.437 4.678-4.438-4.685-.007-.008-.008-.007a2.53 2.53 0 0 1-.466-2.91l.004-.007.003-.006c.17-.356.421-.664.732-.898.31-.234.672-.388 1.052-.45h.008a2.45 2.45 0 0 1 1.169.082c.378.122.723.334 1.005.619l.012.012.012.01.244.227a.997.997 0 0 0 1.354 0l.26-.24.01-.01.011-.01a2.48 2.48 0 0 1 1-.611c.376-.12.774-.147 1.161-.08l.01.002c.38.061.742.215 1.054.45.311.234.564.542.735.898l.005.011a2.537 2.537 0 0 1-.47 2.918Z'
      stroke='inherit'
      strokeWidth={1.5}
    />
    <path
      d='M5.078 2.153h11.51M5.078 6.596h11.51M5.078 11.04H7.38M1.913 1.875c.057 0 .112.016.16.047a.28.28 0 0 1 .106.124.269.269 0 0 1-.063.303.291.291 0 0 1-.313.06.286.286 0 0 1-.13-.102.271.271 0 0 1 .036-.35.293.293 0 0 1 .204-.082M1.913 6.319c.057 0 .112.016.16.046a.28.28 0 0 1 .106.125.269.269 0 0 1-.063.303.291.291 0 0 1-.313.06.286.286 0 0 1-.13-.102.271.271 0 0 1 .036-.351.293.293 0 0 1 .204-.081M1.913 10.762c.057 0 .112.017.16.047a.28.28 0 0 1 .106.125.269.269 0 0 1-.063.303.291.291 0 0 1-.313.06.286.286 0 0 1-.13-.103.271.271 0 0 1 .036-.35.293.293 0 0 1 .204-.082'
      stroke='inherit'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export { WishlistMisc }
